import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  const footerLinks = [
    {
      title: '快速导航',
      links: [
        { label: '首页', to: '/' },
        { label: '娱乐搞笑', to: '/category/entertainment' },
        { label: '教程学习', to: '/category/tutorial' },
        { label: '科技数码', to: '/category/tech' },
        { label: '关于我们', to: '/about' },
      ],
    },
    {
      title: '热门文章',
      links: [
        { label: '平台使用教程', to: '/article/platform-guide-2024' },
        { label: '推荐算法解析', to: '/article/content-recommendation-algorithm' },
        { label: '视频创作指南', to: '/article/video-creation-tips' },
        { label: '移动端功能详解', to: '/article/mobile-app-features' },
      ],
    },
    {
      title: '关于平台',
      links: [
        { label: '品牌介绍', to: '/about' },
        { label: '平台声誉', to: '/about#reputation' },
        { label: '联系方式', to: '/about#contact' },
      ],
    },
  ];

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl text-white"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-5">
              {siteInfo.description.slice(0, 60)}...
            </p>
            <div className="flex items-center gap-3">
              <a href={siteInfo.socialLinks.weibo} target="_blank" rel="nofollow noopener" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm text-background-200"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm text-background-200"></i>
              </a>
              <a href={siteInfo.socialLinks.qq} target="_blank" rel="nofollow noopener" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center cursor-pointer hover:bg-primary-500 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line text-sm text-background-200"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-heading font-bold text-background-50 mb-4">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {siteInfo.foundingYear}-{new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">
              隐私政策
            </Link>
            <Link to="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">
              服务条款
            </Link>
            <Link to="/about#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}